// extracted by mini-css-extract-plugin
export default {"lds-roller":"style_lds-roller__z4dyY","div-after":"style_div-after__bjjPO"};